export default __webpack_public_path__ + "static/media/sitecore.625a31d7.svg";